import { css } from "@emotion/react";

export const styles = {
  p: { margin: 0 },
};

export default styles;
